import React from 'react'
import "../articles.css"

import rodolfo from "../../../../assets/images/articles/coal.jpeg"
import { Byline, Published } from "../.."

export default function Article5Doc() {
  return (
    <div className='emas__articles'>
    <div className='emas__articles-container'>
        <img className="emas__articles-container_headImage" src={rodolfo} alt="rodolfo"></img>
        <div className='emas__articles-container_photo'>
          <i >Photo by Pixabay: https://www.pexels.com/photo/black-close-up-coal-dark-46801/</i>
        </div>
        <h1>Coal generation offer prices </h1>
        <div className='emas__articles-container_publish'>
          <p></p>
        </div>
        <div className='emas__articles-container_body'>
                <p>December 2023</p>
                <p>The protracted issues over coal supplies to generators in the WEM has led to speculation about the marginal cost of coal generation.    </p>
                <p>For background see this <a href='https://www.abc.net.au/news/2022-12-04/synergy-imported-coal-with-high-ash-content-from-nsw/101731306'>article</a> by the ABC and <a href='https://www.abc.net.au/news/2022-11-26/failed-griffin-coal-indian-owners-seek-almost-1-billion/101695318'>this article.</a> We had been expecting a higher marginal cost for coal generation as a result of either imported coal (including any blending costs) being more expensive than local coal or renegotiated contracts. </p>
                <p>Prior to the new market commencing in October 2023, Synergy provided its offers as a portfolio, and therefore the offer prices of individual coal generators were not transparent. We had estimated in late 2022 that Synergy was offering its coal generators at around $50 to $60 per MW and then in mid-2023 we estimated the offer prices had lifted to be between $60 to $70 per MW; however, we could not be sure what Synergy was actually offering because it was not required to provide this information.</p>
                <p>Under the new market rules, Synergy is required to offer each of its coal generators separately. We can see that the offer prices of the coal generators are ranging from $68 to $73 per MW, which is higher than we had previously estimated. It will be interesting to see if Synergy's coal offers stabilise at the current level. </p>
      </div>
        <Published />
    </div>
</div>
  )
}
